import { Component, computed, Input, input } from '@angular/core';
import {
  backToOriginLabel,
  CtBatchSource,
  UserChangedMessageComponent,
} from '@ps-gui/claims-terminal-shared';
import { DynamicDialogComponent } from './dynamic-dialog.component';
import { DynamicDialog } from './dynamic-dialog';

@Component({
  imports: [DynamicDialogComponent, UserChangedMessageComponent],
  selector: 'ct-extraction-user-changed-dialog',
  templateUrl: './user-changed-dialog.component.html',
})
export class UserChangedDialogComponent implements DynamicDialog<boolean> {
  @Input() newUser = '';
  readonly ctBatchSource = input.required<CtBatchSource>();

  protected readonly backLabel = computed(() => backToOriginLabel(this.ctBatchSource()));
}
